import { format, subDays } from 'date-fns';

type PeriodType = {
  label: string;
  value: string;
  isActived: boolean;
};

export const today = format(new Date(), 'yyyy-MM-dd');

export const defaultChartPeriod = (selectedFilter): PeriodType[] => [
  {
    label: 'Today',
    value: today,
    isActived: selectedFilter === today,
  },
  {
    label: 'Past Week',
    value: format(subDays(new Date(), 7), 'yyyy-MM-dd'),
    isActived: selectedFilter === format(subDays(new Date(), 7), 'yyyy-MM-dd'),
  },
  {
    label: 'Past Month',
    value: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
    isActived: selectedFilter === format(subDays(new Date(), 30), 'yyyy-MM-dd'),
  },
];

export function getPercentageFromBiggestNumber(data: any[]): any[] {
  if (!data.length) return [];
  const biggestNumber = Math.max(...data.map(({ total }) => total));
  if (!biggestNumber) return data.map((d) => ({ ...d, percentage: 0 }));
  return data.map((d) => {
    return {
      ...d,
      percentage: (d.total / biggestNumber) * 100,
    };
  });
}

export function getPercentageAcceptanceRejection(data: any[], biggestNumber: number): any[] {
  if (!data.length || !biggestNumber || biggestNumber === -Infinity) {
    return data.map((d) => ({
      ...d,
      chart: { ...d.chart, trioPercentage: 0, partnersPercentage: 0 },
    }));
  }
  return data.map((d) => {
    return {
      ...d,
      chart: {
        ...d.chart,
        trioPercentage: (d.chart.trio / biggestNumber) * 100,
        partnersPercentage: (d.chart.partners / biggestNumber) * 100,
      },
    };
  });
}

export const newCandidateColors = ['#6A92E9', '#376EE2', '#054AD9', '#043EAF', '#043387'];
